import React, { useEffect, useState } from "react";
import DynamicTable from "../../components/DynamicTable";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../components/Loader";
import ErrorMessage from "../../components/ErrorMessage";
import CreateModal from "../../modals/CreateModal";
import EditModal from "../../modals/EditModal";
import DeleteRowModal from "../../modals/DeleteRowModal";
import DeleteAllModal from "../../modals/DeleteAllModal";
import RestoreRowModal from "../../modals/RestoreRowModal";
import RestoreAllModal from "../../modals/RestoreAllModal";
import { Box, Button, Collapse } from "@mui/material";
import { KeyboardArrowUp, KeyboardArrowDown } from "@mui/icons-material";
import {
  getAction,
  createAction,
  updateAction,
  softDeleteAction,
  softDeleteAllAction,
  deleteRowAction,
  deleteAllAction,
  restoreRowAction,
  restoreAllAction,
} from "../../store/actions/whatIsNew";
import { DecodeUserRole, DecodeUsername } from "../../hooks/userData";
const moment = require("moment");

const Videos = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.whatIsNew.data);
  const loading = useSelector((state) => state.whatIsNew.loading);
  const error = useSelector((state) => state.whatIsNew.error);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showCreateModal, setCreateModal] = useState(false);
  const [showEditModal, setEditModal] = useState(false);
  const [showDeleteRowModal, setDeleteRowModal] = useState(false);
  const [showDeleteAllModal, setDeleteAllModal] = useState(false);
  const [showRestoreRowModal, setRestoreRowModal] = useState(false);
  const [showRestoreAllModal, setRestoreAllModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(false);
  const [selectedTable, setSelectedTable] = useState(false);
  const [showDeletedTables, setShowDeletedTables] = useState(false);
  const userRole = DecodeUserRole();
  const username = DecodeUsername();

  useEffect(() => {
    dispatch(getAction());
  }, [dispatch]);

  const activeData = data
    ?.filter((item) => !item.isDeleted && !item.image)
    .map((item) => {
      const {
        createdAt,
        updatedAt,
        isDeleted,
        deletedAt,
        deletedBy,
        service,
        image,
        ...rest
      } = item;

      return {
        ...rest,
      };
    });

  const deletedData = data
    ?.filter((item) => item.isDeleted && !item.image)
    .map((item) => {
      const {
        createdAt,
        updatedAt,
        isDeleted,
        deletedAt,
        service,
        image,
        ...rest
      } = item;

      const formattedDeletedAt = moment(deletedAt).format("DD/MM/YYYY hh:mm A");

      return {
        ...rest,
        deletedAt: formattedDeletedAt,
      };
    });

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "5em" }}>
      {(userRole === "admin" || userRole === "superadmin") && (
        <>
          <Box>
            {loading ? (
              <Loader />
            ) : error ? (
              <ErrorMessage message={error} />
            ) : (
              <>
                <CreateModal
                  onClose={() => setCreateModal(false)}
                  showCreateModal={showCreateModal}
                  table={selectedTable}
                  action={createAction}
                  username={username}
                  hasTitle={false}
                  hasDescription={false}
                  hasImage={false}
                  hasVideo={true}
                  type={"video"}
                  hasId
                />

                <EditModal
                  onClose={() => setEditModal(false)}
                  showEditModal={showEditModal}
                  selectedRow={selectedRow}
                  table={selectedTable}
                  image={selectedImage}
                  action={updateAction}
                  username={username}
                  hasTitle={false}
                  hasDescription={false}
                  hasImage={false}
                  hasVideo={true}
                  type={"video"}
                  hasId
                />

                <DynamicTable
                  data={activeData}
                  setSelectedImage={setSelectedImage}
                  setCreateModal={setCreateModal}
                  setDeleteAllModal={setDeleteAllModal}
                  setDeleteRowModal={setDeleteRowModal}
                  setSelectedRow={setSelectedRow}
                  setEditModal={setEditModal}
                  table={"Videos"}
                  setSelectedTable={setSelectedTable}
                />
              </>
            )}
          </Box>
        </>
      )}
      {userRole === "superadmin" && (
        <>
          <Box>
            <Button onClick={() => setShowDeletedTables(!showDeletedTables)}>
              {showDeletedTables
                ? "Hide Deleted Tables"
                : "Show Deleted Tables"}{" "}
              {showDeletedTables ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </Button>

            <Collapse in={showDeletedTables}>
              {loading ? (
                <Loader />
              ) : error ? (
                <ErrorMessage message={error} />
              ) : (
                <>
                  <RestoreRowModal
                    onClose={() => setRestoreRowModal(false)}
                    showRestoreRowModal={showRestoreRowModal}
                    id={selectedRow?.id}
                    table={selectedTable}
                    action={restoreRowAction}
                    username={username}
                  />

                  <RestoreAllModal
                    onClose={() => setRestoreAllModal(false)}
                    showRestoreAllModal={showRestoreAllModal}
                    table={selectedTable}
                    action={restoreAllAction}
                    username={username}
                    type={"video"}
                  />

                  <DeleteRowModal
                    onClose={() => setDeleteRowModal(false)}
                    showDeleteRowModal={showDeleteRowModal}
                    id={selectedRow?.id}
                    table={selectedTable}
                    action={
                      selectedTable === "Deleted Videos"
                        ? deleteRowAction
                        : softDeleteAction
                    }
                    username={username}
                  />

                  <DeleteAllModal
                    onClose={() => setDeleteAllModal(false)}
                    showDeleteAllModal={showDeleteAllModal}
                    table={selectedTable}
                    action={
                      selectedTable === "Deleted Videos"
                        ? deleteAllAction
                        : softDeleteAllAction
                    }
                    username={username}
                    type={"video"}
                  />

                  <DynamicTable
                    data={deletedData}
                    canEdit={false}
                    canCreate={false}
                    canRestore={true}
                    setSelectedImage={setSelectedImage}
                    setRestoreRowModal={setRestoreRowModal}
                    setRestoreAllModal={setRestoreAllModal}
                    setDeleteRowModal={setDeleteRowModal}
                    setDeleteAllModal={setDeleteAllModal}
                    setSelectedRow={setSelectedRow}
                    table={"Deleted Videos"}
                    setSelectedTable={setSelectedTable}
                  />
                </>
              )}
            </Collapse>
          </Box>
        </>
      )}
    </Box>
  );
};

export default Videos;
